import React, { useEffect, useState } from 'react'
import { Button, Input, Modal } from 'semantic-ui-react'
import styled from 'styled-components'

import FormField from '../form/formField'
import DataSelect from '../form/dataSelect'
import { useTalentApi } from '../../store/mainContext'

const Title = styled.h2`
  font-weight: bold !important;
`

const AddCompanyModal = ({ defaults, onCreated, onCancel, open }) => {
  const [errors, setErrors] = useState([])
  const [company, setCompany] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const api = useTalentApi()

  useEffect(() => {
    setErrors([])
  }, [open])

  useEffect(() => {
    if (!defaults) {
      return
    }

    setCompany(defaults)
  }, [defaults])

  if (!open) {
    return null
  }

  const handleOnChange = (e, target) => {
    const newCompany = { ...company }
    newCompany[target.name] = target.value

    if (target.value !== '') {
      setErrors(errors.filter((x) => x !== target.name))
    }

    setCompany(newCompany)
  }

  const addNewCompany = async () => {
    setIsLoading(true)

    try {
      const { data } = await api.post('companies', company)

      setCompany(data)
      onCreated && onCreated(data)
    } catch ({ response }) {
      setErrors(response.data.fields)
    }

    setIsLoading(false)
  }

  return (
    <Modal open={true} size="mini">
      <Modal.Header>
        <Title>New Company</Title>
      </Modal.Header>
      <Modal.Content>
        <FormField label="Name *" error={errors.indexOf('name') !== -1}>
          <Input
            fluid={true}
            error={errors.indexOf('name') !== -1}
            name="name"
            autoFocus
            onChange={handleOnChange}
            placeholder="Company name..."
            value={(company || {}).name}
          />
        </FormField>

        <FormField label="Address" error={errors.indexOf('address') !== -1}>
          <Input
            fluid={true}
            error={errors.indexOf('address') !== -1}
            name="address"
            onChange={handleOnChange}
            placeholder="Company address..."
          />
        </FormField>

        <FormField label="Website" error={errors.indexOf('website') !== -1}>
          <Input
            fluid={true}
            error={errors.indexOf('website') !== -1}
            name="website"
            onChange={handleOnChange}
            placeholder="Company website..."
          />
        </FormField>

        <FormField label="LinkedIn" error={errors.indexOf('linkedin') !== -1}>
          <Input
            fluid={true}
            error={errors.indexOf('linkedin') !== -1}
            name="linkedin"
            onChange={handleOnChange}
            placeholder="Company Linkedin..."
          />
        </FormField>

        <FormField label="Timezone" error={errors.indexOf('timezoneId') !== -1}>
          <DataSelect
            url="timezones"
            fluid={true}
            error={errors.indexOf('timezoneId') !== -1}
            name="timezoneId"
            onChange={handleOnChange}
            placeholder="Company Timezone..."
          />
        </FormField>
      </Modal.Content>

      <Modal.Actions>
        <Button basic onClick={onCancel} content="Cancel" />

        <Button
          loading={isLoading}
          content="Save"
          labelPosition="right"
          icon="save"
          onClick={addNewCompany}
          color="black"
        />
      </Modal.Actions>
    </Modal>
  )
}

export default AddCompanyModal
